import { ReactNode } from 'react';
import { cssVars } from './cssVars';
import { palette } from './tokens';

interface AnalyticsThemeProviderProps {
  accent?: string;
  children: ReactNode;
}

export function AnalyticsThemeProvider({
  accent = palette.indigo,
  children,
}: AnalyticsThemeProviderProps) {
  return (
    <div style={{ ...cssVars, '--anl-accent': accent } as React.CSSProperties}>{children}</div>
  );
}
